import { render, staticRenderFns } from "./AddLocalVisionAppointed.vue?vue&type=template&id=7f492c0e&"
import script from "./AddLocalVisionAppointed.vue?vue&type=script&lang=js&"
export * from "./AddLocalVisionAppointed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports